// PWA glue: service-worker registration (https or localhost only), "Update available — reload" toast,
// and the install prompt. The worker itself is public/sw.js (precache list generated at build time).
let installEvt = null;
const installCbs = new Set();
let beforeReload = null;

function secure() {
  return location.protocol === 'https:' || ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname);
}

function updateToast() {
  if (document.querySelector('.fd-update')) return;
  const el = document.createElement('div');
  el.className = 'fd-update';
  el.setAttribute('role', 'status');
  el.innerHTML = `<span><b>Update available.</b> A new version of Landman is ready.</span>
    <button type="button" class="fd-btn sm primary" data-act="reload">Reload</button>
    <button type="button" class="fd-btn sm ghost" data-act="later" aria-label="Dismiss">Later</button>`;
  el.addEventListener('click', (e) => {
    const a = e.target.closest('[data-act]')?.dataset.act;
    if (a === 'later') el.remove();
    if (a === 'reload') {
      try { beforeReload?.(); } catch (err) { console.warn(err); }
      location.reload();
    }
  });
  document.body.appendChild(el);
}

export const pwa = {
  register() {
    if (!('serviceWorker' in navigator) || !secure()) return;
    if (new URLSearchParams(location.search).has('nosw')) return;
    const hadController = !!navigator.serviceWorker.controller;
    let shown = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      // First install claims the page silently; only a *replacement* worker means a new deploy.
      if (hadController && !shown) { shown = true; updateToast(); }
    });
    const go = () => navigator.serviceWorker.register('./sw.js', { scope: './' }).then((reg) => {
      const check = () => reg.update().catch(() => {});
      setInterval(check, 30 * 60 * 1000);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
    }).catch((e) => console.warn('[pwa] service worker registration failed', e));
    if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
  },
  // Called before an update reload (main.js saves the game and asks the title screen to resume).
  setBeforeReload(fn) { beforeReload = fn; },
  onInstallable(cb) { installCbs.add(cb); cb(!!installEvt); return () => installCbs.delete(cb); },
  async promptInstall() {
    if (!installEvt) return false;
    installEvt.prompt();
    const r = await installEvt.userChoice.catch(() => null);
    installEvt = null;
    installCbs.forEach((cb) => cb(false));
    return r?.outcome === 'accepted';
  },
};

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  installEvt = e;
  installCbs.forEach((cb) => cb(true));
});
window.addEventListener('appinstalled', () => { installEvt = null; installCbs.forEach((cb) => cb(false)); });
